<header id="menu-bar" [class.menu-bar--dashboard]="showDashboardHero" [style.--hero-collapse]="heroCollapseProgress">
  <div class="menu-top-row">
    <div class="menu-left">
      <a class="brand-block" href="/" (click)="$event.preventDefault(); backButtonClicked()"
         [attr.aria-label]="'VISP, ' + brandSlogan + ' (start page)'">
        <img class="brand-logo" [src]="themeService.theme === 'dark' ? brandLogoDarkPath : brandLogoPath" [alt]="'VISP – ' + brandSlogan">
      </a>

      <button *ngIf="showBackToDashboardButton" id="visp-back-button" (click)="backButtonClicked()" aria-label="Back to dashboard">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <span>Back to dashboard</span>
      </button>
    </div>

    <div class="topbar-actions">
      <div *ngIf="showUserActions" class="notification-wrapper" (click)="$event.stopPropagation()">
        <button class="icon-button notification-button" aria-label="Notifications" (click)="toggleNotificationsPanel($event)">
          <i class="fa fa-bell-o" aria-hidden="true"></i>
          <span *ngIf="unreadNotificationCount > 0" class="notification-dot"></span>
        </button>

        <div class="notifications-panel" *ngIf="isNotificationsPanelOpen" role="dialog" aria-label="Notifications panel">
          <div class="notifications-panel__header">
            <h3>Notifications</h3>
            <button class="notifications-panel__clear-button" *ngIf="notifications.length > 0" (click)="clearNotifications()">
              Clear
            </button>
          </div>

          <ul class="notifications-panel__list" *ngIf="notifications.length > 0; else noNotificationsTemplate">
            <li class="notifications-panel__item" *ngFor="let notification of notifications; trackBy: trackByNotificationId">
              <div class="notifications-panel__item-type" [ngClass]="'notifications-panel__item-type--' + notification.type">
                {{ notification.type }}
              </div>
              <p>{{ notification.message }}</p>
              <time>{{ notification.createdAt | date:'HH:mm:ss' }}</time>
            </li>
          </ul>

          <ng-template #noNotificationsTemplate>
            <p class="notifications-panel__empty">No notifications yet.</p>
          </ng-template>

          <button class="notifications-panel__close-button" (click)="closeNotificationsPanel($event)">
            Close
          </button>
        </div>
      </div>

      <button class="icon-button theme-toggle" (click)="themeService.toggle()"
              [attr.aria-label]="themeService.theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
              [attr.title]="themeService.theme === 'dark' ? 'Light mode' : 'Dark mode'">
        <i class="fa fa-adjust" aria-hidden="true"></i>
      </button>

      <app-help-ctrl *ngIf="containerSessionViewActive"></app-help-ctrl>
      <app-user></app-user>
    </div>
  </div>

  <div class="menu-hero-content" *ngIf="showDashboardHero">
   <div class="menu-hero-inner">
    <ng-container *ngIf="showSignedInHero; else signedOutHeroTemplate">
      <div class="menu-hero-badge">{{ greetingLine }}</div>
      <h1>Your speech research,<br><span>secured and organized.</span></h1>
      <p>
        Manage projects, transcribe recordings, and collaborate with your team
        in one modern workspace.
      </p>
      <div class="menu-hero-actions">
        <button id="tutorial-create-project-btn" class="hero-btn hero-btn-primary" (click)="createProject()" [disabled]="!canCreateProjects">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span>New project</span>
        </button>
        <button class="hero-btn hero-btn-help" (click)="openHelpDialog()">
          <i class="fa fa-question-circle" aria-hidden="true"></i>
          <span>Help</span>
        </button>
      </div>
    </ng-container>

    <ng-template #signedOutHeroTemplate>
      <ng-container *ngIf="showSignedOutHero">
        <div class="menu-hero-badge">Welcome to VISP</div>
        <h1>Research speech data,<br><span>with one shared platform.</span></h1>
        <p>
          Visible Speech is a collection of research tools for speech analysis.
          If you need access to the system, contact us at
          <a href="mailto:support@humlab.umu.se">support&#64;humlab.umu.se</a>.
        </p>
        <app-signin-ctrl></app-signin-ctrl>
      </ng-container>
    </ng-template>
   </div>
  </div>
</header>
